import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import PaymentFailureIcon from "../../assets/img/PaymentOnboardingFailed.svg";
import User from "../../services/user.service";
import Storage from '../../services/storage.service';
import Settings from '../../services/settings.service';
import SpinnerTimeLoader from '../shared/timeLoading';
import DownloadApps from '../shared/DownloadApps';

const subscriptions = [];
const PaymentFailure = props => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [error, setError] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        setLoader(true);
        Storage.get_obsrv("paymentErrorCode").subscribe(data => {
            setError(data);
            let err = data ? data.toString().replace('-', '_') : "";
            setErrorMsg("error" + err);
        });

        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )
        setLoader(false);
        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const paymentHandling = () => {
        setLoader(true);
        Storage.clear("paymentFailedError");
        Storage.clear("paymentErrorStatus");
        Storage.clear("calledFeatureConfirmation");
        Storage.clear("confirmSuccess");
        Storage.clear("confirmFailed");
        Storage.clear("paymentSuccess");
        User.fetchFlowStatus().then(() => {
            setLoader(false);
            window.location.href = "/join/#/pay/";
        }).catch(() => {
            setLoader(false);
            Storage.clear("paymentFailedError");
            Storage.clear("paymentErrorStatus");
            window.location.reload();
        });
    }

    return (<div className="payment-summary-success-failure">
        {loader ? <SpinnerTimeLoader /> :
            <div className="payment-summary-failure">
                <img src={PaymentFailureIcon} alt={translationKeys["payment_not_completed"]}></img>
                <div className='payment-success-title'>
                    {translationKeys["payment_not_completed"]}
                </div>
                <div className='payment-success-desc'>
                    {translationKeys[errorMsg] || translationKeys["payment_failure_desc"]}<br/> 
                    {error ? <>{translationKeys["stm_general_failed_err_code"]}{" "}{error}</> : ""}<br/><br/>
                    {translationKeys[errorMsg + "_desc"] || translationKeys["payment_failure_sub_desc"]}
                </div>
                <button className="common-button" onClick={paymentHandling}> {translationKeys["ob_try_again"]}</button>
                <DownloadApps
                    info={translationKeys["scr_3.3.3_app_download_info"]}
                    classes={"download-apps"}
                    google_play_link={Settings.google_play_link}
                    app_store_link={Settings.app_store_link}
                    huawei_store_link={Settings.huawei_store_link}
                />
            </div>
        }
    </div>
    )
}

export default PaymentFailure;